<main>
  <l-list-loading *ngIf="isLoading" />

  <l-list-header
    title="Listagem de usuários"
    subtitle="Liste e gerencie todos os usuários da plataforma"
  >
    <div class="flex flex-col lg:flex-row gap-2 lg:justify-end">
      <button lButton bType="primary" outline (click)="filter.open()">
        <l-icon class="text-2xl mr-2" icon="filter_list" />
        Filtro {{ amountFilters ? amountFilters : '' }}
      </button>

      <button lButton bType="primary" outline [lDisabled]="isExporting" (click)="export()">
        <l-icon class="text-2xl mr-2">export_notes</l-icon> Exportar
      </button>

      <a *lHasPermission="[resourceEnum.USERS, permissionEnum.CREATE]" lButton bType="primary" routerLink="crud">
        <l-icon class="text-2xl" icon="add" />
        <p class="ml-2 whitespace-nowrap">Novo aluno</p>
      </a>
    </div>
  </l-list-header>

  <l-list-container
    [size]="size"
    [page]="source.page"
    [data]="source.data"
    [sort]="sort"
    [total]="source.total"
    [isLoading]="isLoading"
    (pageChange)="onChangePage($event)"
    (sortChange)="onChangeSort($event)"
  >
    <ng-template #header>
      <th class="w-20" lSortable="id">id</th>
      <th class="w-48" lSortable="name">Nome</th>
      <th class="w-80">E-mail</th>
      <th>Criado em</th>
      <th>Ativo?</th>
      <th></th>
    </ng-template>

    <ng-template #body let-c>
      <td>{{ c.id }}</td>
      <td>{{ c.name }}</td>
      <td>{{ c.email || '-' }}</td>
      <td>
        {{ c.createdAt | date: "dd/MM/yyyy - HH:mm'h'" }}
      </td>
      <td class="text-center">
        <span
          [pTooltip]="c.isActive ? 'Ativado' : 'Desativado'"
          class="flex cursor-pointer text-xl !h-7 !w-7 rounded-full"
          [ngClass]="c.isActive ? 'bg-lSuccess' : 'bg-lDanger'"
        >
          <l-icon class="m-auto text-white" [icon]="c.isActive ? 'check' : 'close'" />
        </span>
      </td>
      <td>
        <div class="flex justify-end gap-4">
          <span
            pTooltip="Editar"
            class="flex cursor-pointer !h-7 !w-7 rounded-full bg-lPrimary"
          >
            <l-icon class="m-auto text-white !text-lg" icon="edit" />
          </span>

          <span
            pTooltip="Deletar"
            class="flex cursor-pointer !h-7 !w-7 rounded-full bg-lDanger"
          >
            <l-icon class="m-auto text-white !text-lg" icon="delete" />
          </span>
        </div>

      </td>
    </ng-template>
  </l-list-container>
</main>

<l-filter #filter>
  <form class="p-1" [formGroup]="filter.formGroup">
      <label class="subtext-color" for="user-list-user-id">Identificação do usuário</label>
      <input id="user-list-user-id" lInput formControlName="userId" />
  </form>
</l-filter>
